import { useEffect, useMemo, useState } from 'react'

export const LAST_CLAIM_TIMESTAMP_KEY = 'LAST_CLAIM_TIMESTAMP'

export function useRecentlyClaimed() {
	const [now, setNow] = useState<number>(Date.now())

	useEffect(() => {
		const interval = setInterval(() => {
			setNow(Date.now())
		}, 1000)

		return () => {
			clearInterval(interval)
		}
	}, [])

	const on = () => {
		localStorage.setItem(LAST_CLAIM_TIMESTAMP_KEY, `${Date.now()}`)
	}

	const isRecentlyClaimed = useMemo(() => {
		const timestampValue = localStorage.getItem(LAST_CLAIM_TIMESTAMP_KEY)

		if (!timestampValue) {
			return false
		}

		const lastClaimTimestamp = Number.parseInt(timestampValue, 10)
		if (Number.isNaN(lastClaimTimestamp)) {
			return false
		}

		const delta = 1000 * 60 * 10 // ten minutes

		return lastClaimTimestamp + delta > now
	}, [now])

	return { isRecentlyClaimed, on }
}
